// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "a/so/journeys/static/js/" + chunkId + "." + "9ad8b8ae" + ".chunk.js";
};